var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5C0 4.25308 4.25308 0 9.5 0C14.7469 0 19 4.25308 19 9.5C19 14.7469 14.7469 19 9.5 19C4.25308 19 0 14.7469 0 9.5ZM9.5 5.84615C9.69381 5.84615 9.87969 5.92315 10.0167 6.06019C10.1538 6.19724 10.2308 6.38311 10.2308 6.57692V10.2308C10.2308 10.4246 10.1538 10.6105 10.0167 10.7475C9.87969 10.8845 9.69381 10.9615 9.5 10.9615C9.30619 10.9615 9.12031 10.8845 8.98327 10.7475C8.84622 10.6105 8.76923 10.4246 8.76923 10.2308V6.57692C8.76923 6.38311 8.84622 6.19724 8.98327 6.06019C9.12031 5.92315 9.30619 5.84615 9.5 5.84615ZM9.5 13.8846C9.69381 13.8846 9.87969 13.8076 10.0167 13.6706C10.1538 13.5335 10.2308 13.3477 10.2308 13.1538C10.2308 12.96 10.1538 12.7742 10.0167 12.6371C9.87969 12.5001 9.69381 12.4231 9.5 12.4231C9.30619 12.4231 9.12031 12.5001 8.98327 12.6371C8.84622 12.7742 8.76923 12.96 8.76923 13.1538C8.76923 13.3477 8.84622 13.5335 8.98327 13.6706C9.12031 13.8076 9.30619 13.8846 9.5 13.8846Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionWarning);
export default __webpack_public_path__ + "static/media/production-warning.fc6a1790bc1f88b49ddc7f85a4eb4f57.svg";
export { ForwardRef as ReactComponent };